import { Injectable, forwardRef, Inject } from '@angular/core'


import { UserTask, Task, PathNode } from '@mprep/shared/data/models'
import { UserTaskService, PathService } from '@mprep/shared/data/services'

import {
  PathFilterSpec,
  Filter
} from './../'

@Injectable()
export class PathFilterService {

  private _userTaskService: UserTaskService

  constructor(
    @Inject(forwardRef(() => UserTaskService)) _userTaskService,
    private _pathService: PathService
  ) {

    this._userTaskService = _userTaskService
  }

  public filterPathBy(path: PathNode, filters: PathFilterSpec): PathNode {
    const pathCopy = path.clone()
    pathCopy.pathNodes.forEach((unit: PathNode) => {
      if (Array.isArray(filters['section']) && filters['section'].length > 0) {
        unit.pathNodes = Filter.applyFilters(filters['section'], unit.pathNodes)
      }
    })

    return pathCopy
  }

  public getPathWithStarredTasks(path: PathNode) {
    const pathCopy: PathNode = this.createTaskResultContainerNode(path.title)
    let taskFound: boolean

    return this._userTaskService.findAllModels(['task'])
      .map((userStarredTasks: UserTask[]) => {
        userStarredTasks = userStarredTasks.filter((userTask: UserTask) => userTask.flagged === 1)

        path.pathNodes.forEach((unit: PathNode, unitIndex) => {
          pathCopy.pathNodes.push(this.createTaskResultContainerNode(unit.title))
          unit.pathNodes.forEach((section: PathNode, sectionIndex) => {
            pathCopy.pathNodes[unitIndex].pathNodes.push(this.createTaskResultContainerNode(section.title))
            section.tasks.forEach((task: Task) => {

              taskFound = userStarredTasks.some((userTask: UserTask, index: number) => {
                if (userTask.task.id === task.id || task.hasChildTask(userTask.task)) {
                  userStarredTasks.splice(index, 1)
                  return true
                }
                return false
              })

              if (taskFound) {
                pathCopy.pathNodes[unitIndex].pathNodes[sectionIndex].tasks.push(task)
              }
            })
          })
        })

        return pathCopy
      })
  }

  private createTaskResultContainerNode(title: string, tasks: Task[] = []): PathNode {
    return this._pathService.createModel({title: title, tasks: tasks, pathNodes: []})
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/path-filter.service.ts